import { BookingFormField } from '@domain/booking-form-field';
import { TicketHolderFormField } from '@domain/ticket-holder-form-field';

export const ensureEmailField = (
  ticketHolderFields: TicketHolderFormField[],
  bookingFields: BookingFormField[]
): TicketHolderFormField[] => {
  if (ticketHolderFields.some((field) => field.slug === 'email')) return ticketHolderFields;

  const emailField = bookingFields.find((field) => field.slug === 'email');
  if (!emailField) return ticketHolderFields;

  const lastNameIndex = ticketHolderFields.findIndex((field) => field.slug === 'lastName');
  const insertIndex = lastNameIndex >= 0 ? lastNameIndex + 1 : ticketHolderFields.length;

  return [...ticketHolderFields.slice(0, insertIndex), emailField, ...ticketHolderFields.slice(insertIndex)];
};
